import breadcrumbsMeta from "@/graphql/breadcrumbsMeta/resolvers";

const items = {
	breadcrumbsMeta
};

export let typeDefs = {};
export let resolvers = {};

Object.keys(items).forEach(key => {
	typeDefs = { ...items[key].typeDefs, ...typeDefs };
	resolvers = { ...items[key].resolvers, ...resolvers };
});



// WEBPACK FOOTER //
// ./src/graphql/resolvers.js